import { useMutation, useQueryClient } from '@tanstack/react-query';
import { customFetchClientSide } from 'src/api/customFetchClientSide';
import { INNER_API_ROUTES } from 'src/constants';

type RestoreSubscriptionParams = {
  app: string;
  user_id: string;
  email: string;
};

const restoreSubscription = async (
  params: RestoreSubscriptionParams,
): Promise<void> => {
  return customFetchClientSide(`${INNER_API_ROUTES.RESTORE_SUBSCRIPTION}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });
};

export function useRestoreSubscription() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RestoreSubscriptionParams) =>
      restoreSubscription(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });
}
